import { getApiBaseUrl } from '../../core/config/api';

/**
 * Téléchargement du launcher OpSecours (ouvert à tout compte connecté).
 * La route exige le jeton Bearer : on récupère le fichier en blob puis on déclenche
 * l'enregistrement navigateur (un simple <a href> ne transmettrait pas le jeton).
 */
export async function downloadLauncher(): Promise<void> {
  const token = localStorage.getItem('token') || localStorage.getItem('authToken');
  const response = await fetch(`${getApiBaseUrl(true)}/launcher/download`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.error || `Erreur HTTP: ${response.status}`);
  }

  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'opsecours-launcher.exe';
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
